export default __webpack_public_path__ + "static/media/Fire.3584b444.png";